import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme();

export default baseTheme;